import React, { useEffect } from 'react';
import InputField from '../../kit/InputField';
import { useTranslation } from 'react-i18next';

/**
 * Professional section of the Contact form.
 * @param {object} props
 * @param {object} props.contact - The initial professional data from a prop.
 * @param {function} props.onUpdate - Callback to bubble state changes back up.
 */
export default function Professional({ contact: initialContact, onUpdate }) {
  const { t } = useTranslation();

  // Initialize state with default empty strings to avoid uncontrolled/controlled warnings
  const [formData, setFormData] = React.useState({
    jobTitle: initialContact?.jobTitle || '',
    companyName: initialContact?.companyName || '',
    companyWebsite: initialContact?.companyWebsite || '',
    linkedInProfile: initialContact?.linkedInProfile || '',
  });

  const [formErrors, setFormErrors] = React.useState({
    jobTitle: null,
    companyName: null,
    companyWebsite: null,
    linkedInProfile: null,
  });

  // Sync state if initialContact prop updates (e.g., after fetching UUID)
  useEffect(() => {
    if (initialContact) {
      setFormData({
        jobTitle: initialContact.jobTitle || '',
        companyName: initialContact.companyName || '',
        companyWebsite: initialContact.companyWebsite || '',
        linkedInProfile: initialContact.linkedInProfile || '',
      });
    }
  }, [initialContact]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };
    
    setFormData(updatedData);

    // Notify parent of the update
    if (onUpdate) {
      onUpdate(updatedData);
    }
  };

  return (
    <div className="space-y-4">
      <InputField
        label={t("professional_job_title_input_label")}
        name="jobTitle"
        placeholder={t("professional_job_title_input_placeholder")}
        required={false}
        value={formData.jobTitle}
        onChange={handleChange}
        error={formErrors.jobTitle}
      />

      <InputField
        label={t("professional_company_name_input_label")}
        name="companyName"
        placeholder={t("professional_company_name_input_placeholder")}
        required={false}
        value={formData.companyName}
        onChange={handleChange}
        error={formErrors.companyName}
      />

      <InputField
        label={t("professional_company_website_input_label")}
        name="companyWebsite"
        placeholder={t("professional_company_website_input_placeholder")}
        type="url"
        required={false}
        value={formData.companyWebsite}
        onChange={handleChange}
        error={formErrors.companyWebsite}
      />

      <InputField
        label={t("professional_linkedin_profile_input_label")}
        name="linkedInProfile"
        placeholder={t("professional_linkedin_profile_input_placeholder")}
        type="url"
        required={false}
        value={formData.linkedInProfile}
        onChange={handleChange}
        error={formErrors.linkedInProfile}
      />
    </div>
  );
}